import { render, staticRenderFns } from "./BriqMultilanguageColumnsPanel.vue?vue&type=template&id=0d6ef64a&scoped=true&lang=pug&"
import script from "./BriqMultilanguageColumnsPanel.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguageColumnsPanel.vue?vue&type=script&lang=js&"
import style0 from "./BriqMultilanguageColumnsPanel.vue?vue&type=style&index=0&id=0d6ef64a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ef64a",
  null
  
)

export default component.exports